/**
 * @desc 保存
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.Response;
export function request(body: defs.tms.CostTypeRequestDto, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/costType/save`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
